import auth from "../Auth";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import * as React from "react";
import axios from "axios";
import { filterBy, groupBy } from "@progress/kendo-data-query";
import Skeleton from "react-loading-skeleton";
import { CalendarCellProps, CalendarChangeEvent, DatePicker, DateTimePicker, MultiViewCalendarChangeEvent } from "@progress/kendo-react-dateinputs";
import { IDropDownModel } from "../Shared/Models/IDropDownModel";
import { datetimeFormatter, errorToastr, successToastr, toLocalDateTime, convertTimeToUTC } from "../../HelperMethods";
import { ErrorComponent } from "../ReusableComponents";
import withValueField from "../Shared/withValueField";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import lookup from "../Lookup/Services";
import { ASSIGNED_DATES_ERROR_MSG, ASSIGNED_PROVIDERS_ERROR_MSG, PROVIDER_ASSIGNED_SUCCESS_MSG, ASSIGNMENT_ALREADY_EXISTS_CONFIRMATION_MSG } from "../Shared/AppMessages";
import { checkUntilInRecurrence } from "../Scheduling/Common/Helper";
import { MultiViewCalendar, CalendarCell } from '@progress/kendo-react-dateinputs';
import ConfirmationModal from '../Shared/ConfirmationModal';
import service from "../Scheduling/Service/Service";

const CustomDropDownList = withValueField(DropDownList);
const defaultItem = { name: "Select Shift..", id: null };
const defaultShiftTypes = { name: "Select Shift Type..", id: null };

export interface AssignScheduleShiftProps {
    // props: any;
    onCloseModal: any;
    onOpenModal: any;
    departmentId: string;
    scheduleId: string
    handleGetSchedule?: any;
}

export interface AssignScheduleShiftState {
    shiftTypeId?: string;
    publishedScheduleId?: string;
    generatedScheduleId?: string;
    publishedScheduleShiftId?: string;
    clientId: string;
    submitted: boolean;
    showLoader?: boolean;
    capacity?: any;
    shiftStartDate?: Date;
    shiftEndDate?: Date;
    publishedSchedule: Array<IDropDownModel>;
    originalpublishedSchedule: Array<IDropDownModel>;
    providers: Array<IDropDownModel>;
    originalproviders: Array<IDropDownModel>;
    selectedProviders: any;
    clientPositionId?: string;
    departmentId?: string;
    positionId?: string;
    position?: string;
    shiftStartTime?: any;
    shiftEndTime?: any;
    opened: boolean;
    recurrenceRule: string;
    selectedDates: Date[];
    isMultipleDate: boolean;
    showAlreadyExistModal: boolean;
    shiftTypes: Array<IDropDownModel>;
    originalshiftTypes: Array<IDropDownModel>;
}

class AssignScheduleShift extends React.Component<AssignScheduleShiftProps, AssignScheduleShiftState> {
    public startDate: any;
    public endDate: any;
    overWrite = false;
    constructor(props: AssignScheduleShiftProps) {
        super(props);
        this.state = {
            clientId: auth.getClient(),
            shiftStartDate: new Date(new Date(new Date().setHours(9)).setMinutes(0)),
            shiftEndDate: new Date(new Date(new Date().setHours(10)).setMinutes(0)),
            submitted: false,
            publishedSchedule: [],
            originalpublishedSchedule: [],
            showLoader: true,
            providers: [],
            originalproviders: [],
            selectedProviders: [],
            departmentId: this.props.departmentId,
            position: "",
            recurrenceRule: 'FREQ=DAILY;INTERVAL=1',
            opened: false,
            selectedDates: [],
            isMultipleDate: false,
            showAlreadyExistModal: false,
            shiftTypes: [],
            originalshiftTypes: []
        };
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        this.getShiftTypes();
    }

    getShiftTypes = () => {
        this.setState({ showLoader: false });
        service.getShiftTypeLookup().then(async res => {
            this.setState({ shiftTypes: res.data, originalshiftTypes: res.data });
        });
    }

    handleShiftTypeChange = (e) => {
        const id = e.value.id;
        if (id) {
            this.setState({ shiftTypeId: id, publishedScheduleId: null, generatedScheduleId: null, shiftStartDate: new Date(new Date(new Date().setHours(9)).setMinutes(0)), shiftEndDate: new Date(new Date(new Date().setHours(10)).setMinutes(0)), capacity: null, providers: [], originalproviders: [], selectedProviders: [], publishedSchedule: [], originalpublishedSchedule: [], position: "", shiftStartTime: null, shiftEndTime: null, recurrenceRule: 'FREQ=DAILY;INTERVAL=1' });
            this.getPublishedScheduled(id);
        }
        else {
            this.setState({ shiftTypeId: null, publishedScheduleId: null, generatedScheduleId: null, shiftStartDate: new Date(new Date(new Date().setHours(9)).setMinutes(0)), shiftEndDate: new Date(new Date(new Date().setHours(10)).setMinutes(0)), capacity: null, providers: [], originalproviders: [], selectedProviders: [], publishedSchedule: [], originalpublishedSchedule: [], position: "", shiftStartTime: null, shiftEndTime: null, recurrenceRule: 'FREQ=DAILY;INTERVAL=1' });
        }
    }

    getPublishedScheduled = (shiftTypeId) => {
        lookup.getPublishedScheduleLookup(this.props.scheduleId, shiftTypeId)
            .then(async res => {
                this.setState({ publishedSchedule: res.data, originalpublishedSchedule: res.data });
            });
    }

    handleChange = (e) => {
        if (e.value.id == null) {
            this.setState({ publishedScheduleId: null, generatedScheduleId: null, shiftStartDate: new Date(new Date(new Date().setHours(9)).setMinutes(0)), shiftEndDate: new Date(new Date(new Date().setHours(10)).setMinutes(0)), capacity: null, providers: [], originalproviders: [], selectedProviders: [], position: "", shiftStartTime: null, shiftEndTime: null, recurrenceRule: 'FREQ=DAILY;INTERVAL=1' });
        } else {
            var totalCapacity = (e.value.noOfReqPos - e.value.noOfFilledPos);
            this.startDate = new Date(e.value.startDate);
            this.endDate = new Date(e.value.endDate);
            this.setState({ publishedScheduleId: e.value.id, generatedScheduleId: e.value.generatedScheduleId, positionId: e.value.positionId, shiftStartDate: new Date(e.value.startDate), shiftEndDate: new Date(e.value.endDate), capacity: totalCapacity, position: e.value.position, shiftStartTime: e.value.startTime, shiftEndTime: e.value.endTime, recurrenceRule: e.value.recurrenceRule }, () => { this.getProviders(e.value.positionId, datetimeFormatter(e.value.startDate), datetimeFormatter(e.value.endDate), e.value.startTime, e.value.endTime); });
        }
    }

    groupHeaderItemRender = (li) => {
        const itemHeader = (
            <b
                style={{
                    textAlign: 'left'
                }}
            >
                {li.props.children}
            </b>
        );
        return React.cloneElement(li, li.props, itemHeader);
    };

    stickyHeaderRender = (div) => {
        const item = (
            <span
                style={{
                    fontWeight: 900,
                    width: '100%',
                    textAlign: 'left'
                }}
            >
                {div.props.children}
            </span>
        );
        return React.cloneElement(div, div.props, item);
    };

    getProviders = (positionId, startDate, endDate, startTime, endTime) => {
        this.setState({ showLoader: false });
        
        lookup.getSuggestedCandidatesLookup(positionId, startDate, endDate, convertTimeToUTC(startTime), convertTimeToUTC(endTime), auth.getClient(), this.state.shiftTypeId,
            new Date(startTime).toLocaleString(), new Date(endTime).toLocaleString()   )
            .then(async res => {
                const ungrouped = 'Ungrouped';
                const candidatesWithUngrouped = res.data.map((el) => (el.position ? el : { ...el, position: ungrouped }));
                this.setState({ opened: true })
                const groupedData = (groupBy(candidatesWithUngrouped, [{ field: 'candidateType' }]) as any[]).reduce(
                    (res, group) => [...res, ...group.items],
                    []
                )
                this.setState({ providers: groupedData, originalproviders: groupedData });
            });
    }

    handleFilterChange(event) {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }

    filterData(filter, originalArray) {
        const data1 = this.state[originalArray];
        return filterBy(data1, filter);
    }

    isCustom = (item) => { return item.id === undefined; }

    addKey = (item) => { item.id = undefined }

    handleProviderChange = (e) => {
        this.setState({ selectedProviders: e.value });
    }

    openNew = () => {
        this.props.onOpenModal();
    };

    overWriteAvailabilty() {
        this.overWrite = true;
        this.setState({ showAlreadyExistModal: false });
        this.handleSave();
    }

    handleSave = () => {
        this.setState({ submitted: true })

        var rule = this.state.recurrenceRule;
        rule = checkUntilInRecurrence(rule, this.state.shiftEndDate);

        let selectedDate = [];
        this.state.selectedDates.forEach((item) => {
            selectedDate.push(toLocalDateTime(item));
        });
        
        let selectedProviderids = [];
        this.state.selectedProviders.forEach((item) => {
            selectedProviderids.push(item.id);
        });
        var allocatedCapacity = this.state.selectedProviders.length;
        let selectedMultipleDates = [];
        this.state.isMultipleDate && this.state.selectedDates.forEach((item) => {
            selectedMultipleDates.push(item.toString());
        });
        let recurrenceExceptionData = '';
        if (this.state.isMultipleDate && this.state.selectedDates.length>0) {
            recurrenceExceptionData = this.getDeselectedDates(this.state.shiftStartDate, this.state.shiftEndDate, this.state.selectedDates,this.state.shiftStartTime);
        }
        let isValid = this.checkValidations(allocatedCapacity, this.state.capacity, this.state.shiftStartDate, this.state.shiftEndDate);
        this.startDate = this.state.shiftStartDate;
        this.endDate = this.state.shiftEndDate;
        if (isValid) {
            let data = {
                schedulePublishedShiftId: this.state.publishedScheduleId,
                scheduleGeneratedShiftId: this.state.generatedScheduleId,
                allocatedCapacity: allocatedCapacity,
                startDate: toLocalDateTime(this.state.shiftStartDate),
                endDate: toLocalDateTime(this.state.shiftEndDate),
                providerIds: selectedProviderids,
                recurrenceRule: rule,
                selectedSpecificDates:selectedMultipleDates.join(', '),
                recurrenceException: recurrenceExceptionData,
                overWrite: this.overWrite,
                selectedDates: selectedDate,
                isSeries: selectedDate.length <= 0 ? true : false
            };
            if ((this.state.publishedScheduleId != undefined && this.state.publishedScheduleId != null) && (this.state.shiftTypeId != undefined && this.state.shiftTypeId != null) && (this.state.shiftStartDate != undefined && this.state.shiftStartDate != null) && (this.state.position != undefined && this.state.position != null && this.state.position != "")
                && (this.state.shiftEndDate != undefined && this.state.shiftEndDate != null) && (this.state.selectedProviders != undefined && this.state.selectedProviders.length > 0 && this.state.selectedProviders != null)) {
                axios.post(`api/scheduling/published/${this.state.publishedScheduleId}/assign`, JSON.stringify(data)).then((res) => {
                    if (res.data == -999) {
                        this.setState({ showAlreadyExistModal: true });
                        this.overWrite = false;
                        return;
                    }
                    this.overWrite = false;
                    successToastr(PROVIDER_ASSIGNED_SUCCESS_MSG);
                    this.props.onCloseModal();
                    this.props.handleGetSchedule(this.props.scheduleId);
                });
            }
        }
    }

    checkValidations(allocatedCapacity, capacity, startDate, endDate) {
        // if (allocatedCapacity != null && allocatedCapacity != undefined && allocatedCapacity > capacity) {
        //     errorToastr(ASSIGNED_PROVIDERS_ERROR_MSG);
        //     return false;
        // }
        if (startDate != null && endDate != undefined && startDate > endDate) {
            errorToastr(ASSIGNED_DATES_ERROR_MSG);
            return false;
        }
        return true;
    }
    isSameDay = (d1: Date, d2: Date) =>
        d1.getDate() === d2.getDate() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getFullYear() === d2.getFullYear();

    // Handles selection/deselection of dates
    toggleDate = (date: Date) => {
        const { selectedDates } = this.state;
        const alreadySelected = selectedDates.some(d => this.isSameDay(d, date));

        const updatedDates = alreadySelected
            ? selectedDates.filter(d => !this.isSameDay(d, date))
            : [...selectedDates, date];

        this.setState({ selectedDates: updatedDates });
    };

    GetEnabledDay = (props) => {
        const dayMap: { [key: string]: number } = {
            SU: 0,
            MO: 1,
            TU: 2,
            WE: 3,
            TH: 4,
            FR: 5,
            SA: 6,
        };
        const parts = props.split(';'); // Split by ;
        const rule: Record<string, string> = {};

        parts.forEach(part => {
            const [key, value] = part.split('=');
            rule[key] = value;
        });

        // Check frequency
        const isWeekly = rule.FREQ === 'WEEKLY';
        if (isWeekly) {
            const days = rule.BYDAY.split(',');
            return days.map(day => dayMap[day]);
        }
        else {
            return [0, 1, 2, 3, 4, 5, 6, 7];
        }
    }
    // Custom cell renderer to highlight selected dates
    CustomCell = (props: CalendarCellProps) => {
        const { value, className } = props;
        const day = value.getDay();
        const isInRange = value >= new Date(this.state.shiftStartDate) && value <= new Date(this.state.shiftEndDate);
        const isEnabledDay = this.GetEnabledDay(this.state.recurrenceRule).includes(day);
        const isDisabled = !(isInRange && isEnabledDay);
        const isSelected = this.state.selectedDates.some(d => this.isSameDay(d, value));

        return (
            <td
                className={`${className ?? ''} ${isSelected ? 'custom-selected' : ''}${isDisabled ? 'k-calendar-td k-disabled' : ''}`}
                onClick={() => !isDisabled && this.toggleDate(value)}
                role="gridcell"
                aria-selected={isSelected}
                tabIndex={0}
            >
                {value.getDate()}
            </td>
        );
    };
    HandleCheck = (e) => {
        this.setState({ isMultipleDate: e.target.checked });
        if (e.target.checked == false) {
            this.setState({ selectedDates: [] });
        }
    }
    getDeselectedDates(start: Date, end: Date, existingDates: Date[],startTime:Date): string {
        const missingDates: string[] = [];
        const current = new Date(start);
        const time=new Date(startTime);
        while (current <= end) {
            const currentDate = new Date(current);
            currentDate.setHours(time.getHours(), time.getMinutes(), 0, 0);

            const isInExisting = existingDates.some(d =>
                d.toDateString() === currentDate.toDateString()
            );

            if (!isInExisting) {
                missingDates.push(currentDate.toString());
            }

            current.setDate(current.getDate() + 1);
        }

        return missingDates.join(', ');
    }
    render() {
        return (
            <div className="row mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end holdposition-width">
                <div className="modal-content border-0">
                    <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                        <h4 className="modal-title text-white fontFifteen">
                            {"Assign Shifts"}
                        </h4>
                        <button type="button" className="close text-white close_opacity" data-dismiss="modal" onClick={this.props.onCloseModal}>
                            &times;
                        </button>
                    </div>
                    {this.state.showLoader &&
                        Array.from({ length: 2 }).map((item, i) => (
                            <div className="row mx-auto mt-2" key={i}>
                                {Array.from({ length: 3 }).map((item, j) => (
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                        <Skeleton width={230} />
                                        <Skeleton height={30} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    {!this.state.showLoader && (
                        <div className="model-body">
                            <div className="body-inner">
                            <div className="row mt-3 mx-0">
                                <div className="col-12 col-sm-4 mt-1 mt-sm-0">
                                    <label className="mb-0 font-weight-bold required">Shift Type</label>
                                    <CustomDropDownList
                                        className="form-control mt-1"
                                        data={this.state.shiftTypes}
                                        textField="name"
                                        valueField="id"
                                        id="shiftTypes"
                                        name="id"
                                        value={this.state.shiftTypes}
                                        defaultItem={defaultShiftTypes}
                                        onChange={(e) => this.handleShiftTypeChange(e)}
                                        filterable={this.state.originalshiftTypes.length > 5 ? true : false}
                                        onFilterChange={this.handleFilterChange}
                                    />
                                    {this.state.submitted && (this.state.shiftTypeId == undefined || this.state.shiftTypeId == null) && <ErrorComponent />}
                                </div>
                                <div className="col-12 col-sm-8 col-lg-8 mt-1 mt-sm-0">
                                    <label className="mb-0 font-weight-bold required">Shift</label>
                                    <CustomDropDownList
                                        className="form-control mt-1"
                                        data={this.state.publishedSchedule}
                                        textField="name"
                                        valueField="id"
                                        id="publishedSchedule"
                                        name="id"
                                        value={this.state.publishedScheduleId}
                                        defaultItem={defaultItem}
                                        onChange={(e) => this.handleChange(e)}
                                        filterable={this.state.originalpublishedSchedule.length > 5 ? true : false}
                                        onFilterChange={this.handleFilterChange}
                                    />
                                    {this.state.submitted && (this.state.publishedScheduleId == undefined || this.state.publishedScheduleId == null) && <ErrorComponent />}
                                </div>
                            </div>
                            <div className="row mt-3 mx-0">
                                <div className="col-12 col-sm-6 col-md-4 col-lg-4 mt-1 mt-sm-0" id="ShowDatePickerIcon">
                                    <label className="mb-1 font-weight-bold required">Start Date</label>
                                    <div className="row">
                                        <div className="col-12">
                                            <DatePicker
                                                className="form-control"
                                                format="MM/dd/yyyy"
                                                value={new Date(this.state.shiftStartDate)}
                                                min={new Date(this.startDate)}
                                                max={new Date(this.state.shiftEndDate)}
                                                name="shiftStartTime"
                                                onChange={(e) => this.setState({ shiftStartDate: e.target.value }, () => { this.getProviders(this.state.positionId, datetimeFormatter(this.state.shiftStartDate), datetimeFormatter(this.state.shiftEndDate), this.state.shiftStartTime, this.state.shiftEndTime); })}
                                                disabled={(this.state.publishedScheduleId == null || this.state.publishedScheduleId == undefined) ? true : false}
                                                formatPlaceholder="formatPattern"
                                            />
                                            {this.state.submitted && (this.state.shiftStartDate == undefined || this.state.shiftStartDate == null) && <ErrorComponent />}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-md-4 col-lg-4 mt-1 mt-sm-0" id="ShowDatePickerIcon">
                                    <label className="mb-1 font-weight-bold  required">End Date</label>
                                    <div className="row">
                                        <div className="col-12">
                                            <DatePicker
                                                className="form-control"
                                                format="MM/dd/yyyy"
                                                name="endDateTime"
                                                value={new Date(this.state.shiftEndDate)}
                                                onChange={(e) => this.setState({ shiftEndDate: e.target.value }, () => { this.getProviders(this.state.positionId, datetimeFormatter(this.state.shiftStartDate), datetimeFormatter(this.state.shiftEndDate), this.state.shiftStartTime, this.state.shiftEndTime); })}
                                                min={new Date(this.state.shiftStartDate)}
                                                max={new Date(this.endDate)}
                                                disabled={(this.state.publishedScheduleId == null || this.state.publishedScheduleId == undefined) ? true : false}
                                                formatPlaceholder="formatPattern"
                                            />
                                            {this.state.submitted && (this.state.shiftEndDate == undefined || this.state.shiftEndDate == null) && <ErrorComponent />}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-4 mt-1 mt-sm-0">
                                    <label className="mb-0 font-weight-bold required">Position</label>
                                    <input
                                        type="text"
                                        className="form-control mt-1"
                                        placeholder="Enter Shift Name"
                                        value={this.state.position}
                                        maxLength={100}
                                        onChange={(event) => {
                                            this.setState({ position: event.target.value });
                                        }}
                                        disabled={true}
                                    />
                                    {this.state.submitted && (this.state.position.trim() == undefined || this.state.position.trim() == null || this.state.position.trim() == "") && <ErrorComponent />}
                                </div>
                            </div>
                            <div className="row mt-3 mx-0">
                                {/* <div className="col-sm-4 mt-sm-0 mt-2" id="removemargin-border">
                                    <label className="mb-1 font-weight-bold">No. Of Position Required</label>
                                    <NumericTextBox
                                        className="form-control text-right"
                                        disabled={true}
                                        name="duration"
                                        placeholder="Enter Position"
                                        value={this.state.capacity}
                                        title="Maximum value could be 99999."
                                        max={99999}
                                        min={0}
                                        spinners={false}
                                    />
                                </div> */}
                                <div className="col-12 col-sm-8 col-lg-8 mt-1 mt-sm-0">
                                    <label className="mb-1 font-weight-bold required">Provider</label>
                                    <MultiSelect
                                        className="form-control disabled"
                                        data={this.state.providers}
                                        groupField="candidateType"
                                        textField="name"
                                        dataItemKey="id"
                                        id="providers"
                                        value={this.state.selectedProviders}
                                        placeholder="Select Provider..."
                                        onChange={(e) => this.handleProviderChange(e)}
                                        filterable={true}
                                        onFilterChange={this.handleFilterChange}
                                        groupHeaderItemRender={this.groupHeaderItemRender}
                                        groupStickyHeaderItemRender={this.stickyHeaderRender}
                                        // disabled={this.state.capacity == 0}

                                    />
                                    {this.state.submitted && (this.state.selectedProviders == undefined || this.state.selectedProviders.length == 0 || this.state.selectedProviders == null) && <ErrorComponent />}
                                </div>
                            </div>
                            <div className="row mt-3 mx-0">
                                <div className="col-sm-4 mt-sm-0 mt-2" id="removemargin-border">
                                    <label className="mb-1 font-weight-bold">Select Multiple Dates</label>
                                    <label className="container-R d-flex mb-0 pb-3">
                                        <input
                                            type="checkbox"
                                            value="false"
                                            name="selectMultipleDates"
                                            onChange={(e) => this.HandleCheck(e)}
                                            checked={this.state.isMultipleDate}
                                        />
                                        <span className="checkmark-R checkPosition checkPositionTop" style={{ left: "0px" }}></span>
                                    </label>
                                </div>
                            </div>
                                <div className="row mt-3 mx-0" style={{ display: this.state.isMultipleDate ? '' : 'none' }}>
                                    <div className="col-12 col-sm-8 col-lg-8 mt-1 mt-sm-0">
                                        {/* <label className="mb-1 font-weight-bold required">Multi</label> */}
                                        <MultiViewCalendar
                                            views={2}
                                            value={this.state.selectedDates} // No built-in selection
                                            onChange={() => { }}
                                            cell={this.CustomCell}
                                            min={new Date(this.state.shiftStartDate.setHours(0, 0, 0, 0))}
                                            max={new Date(this.state.shiftEndDate)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.onCloseModal}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                            <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleSave}>
                                <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Assign Shifts
                            </button>
                        </div>
                    </div>
                </div>
                <ConfirmationModal
                    message={ASSIGNMENT_ALREADY_EXISTS_CONFIRMATION_MSG()}
                    showModal={this.state.showAlreadyExistModal}
                    handleYes={() => this.overWriteAvailabilty()}
                    handleNo={() => {
                        this.setState({ showAlreadyExistModal: false });
                    }}
                />
            </div>
        );
    }
}
export default AssignScheduleShift;